module.exports = __webpack_public_path__ + "files/d28cf9cc41fd75c3bdb36671ffcc466c.png";